"use strict";
/**
 * Text Management Services Export
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.textManagementService = exports.TextManagementService = void 0;
var textManagementService_1 = require("./textManagementService");
Object.defineProperty(exports, "TextManagementService", { enumerable: true, get: function () { return textManagementService_1.TextManagementService; } });
// Create singleton instance for easy use
const textManagementService_2 = require("./textManagementService");
exports.textManagementService = new textManagementService_2.TextManagementService();
//# sourceMappingURL=index.js.map